import { provideApolloClient } from "@vue/apollo-composable";
import { gqlGetPortfolio } from "@/graphql/portfolios";
import { effectScope } from "vue";
import { apolloClient } from "@/utils/apolloClient";

export const hasBeneficiariesAllowed = async (to) => {
    const scope = effectScope(true);

    try {
        return await scope.run(async () => {
            provideApolloClient(apolloClient);

            try {
                const response = await apolloClient.query({
                    query: gqlGetPortfolio,
                    variables: { portfolioId: to.params.portfolioId },
                    fetchPolicy: 'no-cache',
                });

                const clientInfo = response
                    ?.data
                    ?.clientInfo

                const beneficiariesAllowed = clientInfo
                    ?.portfolio
                    ?.beneficiariesAllowed

                if (beneficiariesAllowed) {
                    return true
                }

                return '/dashboard'
            } catch (error) {
                console.error('Query error:', error);
                return false
            }
        });
    } finally {
        scope.stop();
    }
};